<ng-container *ngIf="isVisible">
  <div [ngClass]="['message-container', messageType]"
       [ngStyle]="{'border-color': customMessageStyle.border, 'background':customMessageStyle.background, 'margin': margin}">
    <span class="message-icon">
      <mat-icon data-cy="icon-{{messageType}}-{{dataCyId}}" [ngStyle]="{'color':customMessageStyle.color}">
      {{(customMessageStyle.icon?customMessageStyle.icon:messageIcon)}}
      </mat-icon>
    </span>
    <span class="con-label" [ngStyle]="{'color':customMessageStyle.color}"
          data-cy="message-{{messageType}}-{{dataCyId}}"
          [innerHTML]="message">
    </span>
    <span class="con-action">
      <ng-container *ngIf="messageActions.length > 0">
        <mat-icon [ngClass]="{'action-icon': true, 'disabled': action.disabled}" *ngFor="let action of messageActions" data-cy="action-message-{{action.actionIdentifier}}-{{dataCyId}}" [ngStyle]="{'color':customMessageStyle.background, 'background-color':customMessageStyle.color}" (click)="emitAction(action)">{{action.icon}}</mat-icon>
      </ng-container>
      <ng-container *ngIf="messageActions.length < 1">
        <mat-icon data-cy="hide-icon-{{messageType}}-{{dataCyId}}" [ngStyle]="{'color':customMessageStyle.color}" *ngIf="canHide" (click)="hide()">close</mat-icon>
      </ng-container>
    </span>
  </div>
</ng-container>
